<template>
    <div>
        <template v-if="is_loading_ev_scroing">
            <div class="font-italic">
                (불러오는 중)
            </div>
        </template>
        <template v-else>
            <div v-if="!ev_scoring_list.length" class="border-0">
                평가요소가 없습니다
            </div>
            <div v-else>
                <template v-if="show_ai_assessment">
                    <a-i-evaluation-component :ev_scoring_list="ev_scoring_list"
                                              :sub_id="sub_id"
                                              :sub_label="sub_label"
                                              :sub_code="sub_code"
                                              @handleChange="handleChange()"
                    />
                </template>
                <template v-else>
                    <user-evaluation-component :ev_scoring_list="ev_scoring_list"
                                               :sub_code="sub_code"
                                               :disabled="disabled"
                                               :is_updating_ev_scoring="is_updating_ev_scoring"
                                               :is_not_applicable="is_not_applicable"
                                               @resetEvaluation="resetEvaluation"
                                               @handleChange="handleChange()"
                    />
                </template>

            </div>

            <template v-if="temp_review.auditor_name">
                <div class="f-90 gray-500 fw-300">
                    {{ temp_review.auditor_name ? 'Audited :' : '' }} {{ temp_review.auditor_name }}
                    {{ temp_review.time_stamp }}
                </div>
            </template>

            <div v-if="is_reviews_loaded">
                <b-overlay :show="show_ai_assessment">
                    <b-form-textarea v-model="temp_review.review_comment"
                                     :class="[temp_review.auditor_name ? 'bg-blue2 border-white' : 'border border-color-gray-600 border-width-1p8', 'mb-2']"
                                     placeholder="현장에서 확인한 사항을 작성하여 주십시오."
                                     :rows="6" max-rows="60"
                                     :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || disabled"
                    >
                    </b-form-textarea>

                    <template v-if="is_not_applicable === null">
                        <div class="f-90 text-light bg-danger rounded p-2 mb-2">
                            어떠한 오류로 인해 같은 문항내 평가기준의 <b>"해당없음"</b> 값이 모두 동일하지 않은 오류가 발생했습니다. 평가를 중단해주시고, 개발팀에 문의해주세요.
                        </div>
                    </template>

                    <div class="d-flex justify-content-between">
                        <div>
                            <template v-if="!isFieldEmpty(ev_scoring_list)">
                                <b-button size="sm" class="mr-2"
                                          :variant="is_not_applicable === true ? 'dark' : 'dark-border'"
                                          :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || is_not_applicable === null"
                                          @click="evaluationSave(is_not_applicable, true)"
                                >
                                    {{ is_not_applicable === true ? `해당없음 취소` : `해당없음 처리` }}
                                </b-button>
                                <b-btn size="sm" :variant="is_not_applicable === true ? 'danger' : 'outline-danger'"
                                       :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || is_not_applicable === null || !is_evs_audited"
                                       @click="resetSubsvaluations"
                                >
                                    전체 초기화
                                </b-btn>
                            </template>
                        </div>


                        <b-button class="ml-auto"
                                  :variant="is_updating_ev_scoring || disabled ? 'mode' : 'blue'"
                                  size="sm"
                                  :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || disabled"
                                  @click="saveReviewComments"
                        >
                            저장하기
                        </b-button>
                    </div>
                    <template #overlay>
                        <div class="text-center gray-600">
                            {{ $t('AI 평가 보기 모드에서는 사용하실 수 없습니다.') }}
                        </div>
                    </template>
                </b-overlay>

            </div>
        </template>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {debounce} from 'lodash';
import UserEvaluationComponent from '@shared/components/admin/components/evaluations/UserEvaluationComponent.vue';
import AIEvaluationComponent from '@shared/components/admin/components/evaluations/AIEvaluationComponent.vue';

export default {
    name: 'evaluation-component',
    components: {AIEvaluationComponent, UserEvaluationComponent},
    props: {
        sub_code: {
            type: String,
            default: null,
        },
        sub_label: {
            type: [String, null],
            default: null,  
        },
        sub_id: {
            type: [Number,null],
            default: null
        },
        sub_description: {
            type: String
        },
        ev_item: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        show_ai_assessment: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            temp_review: {
                sub_code: '',
                auditor_name: '',
                review_comment: '',
                task_comment: '',
                time_stamp: '',
            },
            save_state: 'not_saved',
            validation_comment: '',
            validation_icon: '',
            validation_style: '',
            ev_scoring_list: [],
            is_loading_ev_scroing: false,
            is_updating_ev_scoring: false,
            is_updating_ev_review: false,
        };
    },
    computed: {
        ...mapState('reviews', {
            reviews: state => state.reviews,
            review_campaign_id: state => state.campaign_id,
            is_reviews_loaded: state => state.is_reviews_loaded,
            is_review_saved: state => state.is_review_saved
        }),
        ...mapState('score', ['is_evaluate_loaded', 'is_comment_loaded', 'evaluate_results']),
        ...mapState('questions', ['subs', 'subs_loaded', 'answer_company']),
        ...mapState('industry_scores', ['is_qe_evaluate_loaded']),
        user_name() {
            return this.$store.state.user_name;
        },
        campaign() {
            return this.$store.state.campaign;
        },
        question_name() {
            return this.$store.state.question_composition.question_name;
        },
        question_code() {
            return this.$store.state.question_composition.question_code;
        },
        is_not_applicable() {
            const ev_not_applicable_list = this.ev_scoring_list.map(item => item.manual_not_applicable);
            if (ev_not_applicable_list.every(ev_not_applicable => ev_not_applicable == true)) return true;
            if (ev_not_applicable_list.every(ev_not_applicable => ev_not_applicable == false)) return false;

            // //어떠한 오류로 인해 같은 sub 내의 evaluation.not_applicable이 모두 동일한 값이지 않을 때,
            // throw Error(`Not all 'not_applicable' values are the same within the group in ${this.sub_code}`)
            return null;
        },
        is_evs_audited() {
            return this.ev_scoring_list.some(({is_audited}) => is_audited === true);
        }
    },
    watch: {
        save_state(newValue) {
            if (newValue == 'saving') {
                this.validation_comment = '저장 중 입니다.';
                this.validation_icon = 'hourglass';
                this.validation_style = 'ih-validation-saving';
            } else if (newValue == 'saved') {
                this.validation_comment = '저장 되어있습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-saved';
            } else if (newValue == 'resaved') {
                this.validation_comment = '변경 저장 되었습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-resaved';
            }
        },
        subs_loaded: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.initiateTempReview();
                }
            }
        },
        ev_item: {
            deep: true,
            handler(_updated_ev) {
                this.transformEVData(_updated_ev);
            }
        },
        reviews: {
            deep: true,
            handler() {
                this.initiateTempReview();
            }
        }
    },
    created() {
        this.transformEVData();
        this.$emit('evaluation-load-finished', this.sub_code);
    },
    beforeDestroy() {
        this.update_qe_evaluate_result_loaded(false);
    },
    methods: {
        ...mapMutations('industry_scores', ['update_qe_evaluate_result_loaded']),
        ...mapActions('industry_scores', ['readQeEvaluateResult', 'saveQeEvaluateResult']),
        ...mapActions('reviews', ['initiateReviews', 'saveSubReview']),
        ...mapActions('evaluations', ['setAuditCategory']),
        tempChange: debounce(async function (sub_code, i) {
            await this.evaluationSave(i);
        }, 800),
        transformEVData(_ev_item = this.ev_item) {
            this.ev_scoring_list = [..._ev_item].reduce((_ev_scoring_list, ev_scoring) => {
                const {
                    project_code, campaign_id, company_id, company_name,
                    question_code, sub_code, sub_name,
                    index, audit_comment, author_id, author_name,
                    ev_id, ev_name, ev_score,
                    not_applicable, satisfied, manual_not_applicable, manual_satisfied,
                    review_comment, review_timestamp, reviewer_name,
                    risk, score, task_comment,audit_category_code
                } = ev_scoring;


                const _is_audited = manual_satisfied !== null || manual_not_applicable !== null;
                const _audit_comment = !audit_comment || !audit_comment.trim() ? null : audit_comment.trim();


                _ev_scoring_list.push({
                    project_code, campaign_id, company_id, company_name,
                    question_code, sub_code, sub_name,
                    index,
                    author_id, author_name, is_audited: _is_audited,
                    audit_comment: _audit_comment,
                    ev_id, ev_name, ev_score,

                    satisfied, not_applicable,
                    manual_satisfied: manual_satisfied ?? satisfied,
                    manual_not_applicable: manual_not_applicable ?? not_applicable,

                    review_comment, review_timestamp, reviewer_name,
                    risk, score, task_comment,audit_category_code
                });
                return _ev_scoring_list;
            }, []);
        },
        toggle_manual_satisfied: debounce(async function () {
            await this.handleChange();
        }, 2500), // 4500
        async handleChange() {
            this.is_updating_ev_scoring = true;
            await this.evaluationSave();
            this.is_updating_ev_scoring = false;
        },
        async evaluationSave(manual_not_applicable, force_change_not_applicable = false) {
            try {
                const saving_ev_list = [...this.ev_scoring_list].reduce((_saving_evs, _ev) => {
                    const _ev_item = this.ev_item.find(_ev_ele => _ev_ele.ev_id === _ev.ev_id);
                    if (_ev_item) {
                        if (!_ev_item.target_company_id) {
                            _ev.target_company_id = this.answer_company.company_id;
                        }

                        if (force_change_not_applicable) {
                            _ev.author_id = this.$store.state.user_id;
                            _ev.manual_not_applicable = !manual_not_applicable;
                            _saving_evs.push(_ev);
                        } else if (
                            (
                                (_ev_item.satisfied !== _ev.manual_satisfied)
                                ||
                                (_ev_item.manual_satisfied !== null && _ev_item.manual_satisfied !== _ev.manual_satisfied)
                            )
                            ||
                            (
                                (_ev_item.not_applicable !== _ev.manual_not_applicable)
                                ||
                                (_ev_item.manual_not_applicable !== null && _ev_item.manual_not_applicable !== _ev.manual_not_applicable)
                            )
                        ) {
                            _ev.author_id = this.$store.state.user_id;
                            _saving_evs.push(_ev);
                        } else if (_ev_item.audit_comment !== _ev.audit_comment) {
                            _ev.audit_comment = !_ev.audit_comment || !_ev.audit_comment.trim() ? null : _ev.audit_comment.trim();
                            _saving_evs.push(_ev);
                        }
                        else if (_ev_item.audit_category_code !== _ev.audit_category_code) {
                            _saving_evs.push(_ev);
                        }
                    }

                    return _saving_evs;
                }, []);

                const ev_list = saving_ev_list.map(({
                    ev_id,
                    manual_not_applicable,
                    manual_satisfied,
                    audit_comment,
                    author_id,
                    audit_category_code,
                }) => ({
                    ev_id, author_id,
                    audit_category_code: audit_category_code,
                    comment: audit_comment,
                    not_applicable: manual_not_applicable,
                    satisfied: manual_satisfied
                }));

                const {pc, project_code, cmp, campaign_id, cpn, company_id} = this.$route.query;

                const _campaign_id = cmp ?? campaign_id;
                const _company_id = cpn ?? company_id;
                const _project_code = pc ?? project_code;

                await this.saveQeEvaluateResult({
                    project_code: _project_code,
                    campaign_id: _campaign_id,
                    company_id: _company_id,
                    sub_code: this.sub_code,
                    ev_list: ev_list
                });

                if (force_change_not_applicable) {
                    this.$emit('reset-sub-evaluation');
                } else {
                    this.$forceUpdate();
                }
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '평가 저장 실패', '평가 저장 중 장애가 발생했습니다. 페이지 데이터를 다시 불러옵니다.');
                this.$emit('reset-sub-evaluation');
            }
        },
        async resetEvaluation(i) {
            this.is_updating_ev_scoring = true;
            const reqBody = {
                campaign_id: this.$route.query.cmp,
                company_id: this.$route.query.cpn,
                ev_id: this.ev_scoring_list[i].ev_id,
                sub_code: this.sub_code
            };

            await this.$axios.delete('/delete_audit', {data: reqBody});
            this.$emit('reset-sub-evaluation');
            this.is_updating_ev_scoring = false;
        },
        async resetSubsvaluations() {
            if (this.is_not_applicable) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('잘못된 요청'), // content는 기본값 사용, title만 변경
                    message: this.$t('먼저 해당없음 처리를 취소해주세요.'),
                });
                return;
            }
            try {
                this.is_updating_ev_scoring = true;
                const _promise_init_ev_request = this.ev_scoring_list.reduce((_init_ev_request, _ev) => {
                    if (_ev.is_audited) {
                        _init_ev_request.push(this.$axios.delete('/delete_audit', {
                            data: {
                                campaign_id: this.$route.query.cmp,
                                company_id: this.$route.query.cpn,
                                ev_id: _ev.ev_id,
                                sub_code: this.sub_code
                            }
                        }));
                    }
                    return _init_ev_request;
                }, []);

                await Promise.all(_promise_init_ev_request);
            } catch (error) {
                alert(`죄송합니다. ${this.sub_code} 문항의 평가 전체 초기화 도중 장애가 발생했습니다. 개발팀에 문의해주세요.`);
            } finally {
                this.$emit('reset-sub-evaluation');
                this.is_updating_ev_scoring = false;
            }
        },
        findReviewObj(company_id, sub_code) {
            let idx = this.reviews.findIndex(item => item.company_id == company_id);
            if (this.is_reviews_loaded) {
                if (idx > -1) {
                    let temp_rev = this.reviews[idx].review_results;
                    let review_idx = temp_rev.findIndex(review_item => review_item.sub_code == sub_code);
                    if (review_idx > -1) {
                        return this.reviews[idx].review_results[review_idx];
                    }
                }
            }

            return undefined;
        },
        initiateTempReview() {
            this.is_updating_ev_review = true;
            let temp_rev = this.findReviewObj(this.answer_company.company_id, this.sub_code);
            let review_obj = {};
            if (typeof temp_rev != 'undefined') {
                review_obj = {
                    sub_code: temp_rev.sub_code,
                    auditor_name: temp_rev.auditor_name,
                    review_comment: temp_rev.review_comment,
                    task_comment: temp_rev.task_comment,
                    time_stamp: temp_rev.time_stamp
                };
            } else {
                review_obj = {
                    sub_code: this.sub_code,
                    auditor_name: '',
                    review_comment: '',
                    task_comment: '',
                    time_stamp: '',
                };
            }

            this.temp_review = review_obj;
            this.is_updating_ev_review = false;
        },
        async saveReviewComments() {
            this.is_updating_ev_review = true;
            const {cmp, cpn, campaign_id, company_id} = this.$route.query;
            let review_obj = {
                campaign_id: cmp ?? campaign_id,
                company_id: cpn ?? company_id,
                sub_code: this.sub_code
            };

            if (this.temp_review?.review_comment?.trim()) {
                review_obj.auditor_name = this.user_name;
                review_obj.review_comment = this.temp_review.review_comment;
                review_obj.task_comment = this.temp_review.task_comment;
            } else {
                review_obj.auditor_name = null;
                review_obj.review_comment = null;
                review_obj.task_comment = null;
            }

            await this.saveSubReview(review_obj);
            this.is_updating_ev_review = false;
        },
    }
};
</script>

<style>

</style>
